var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'pThumb flex-col flex__center clickable margin-right-10',
    _vm.active ? 'active' : ''
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"pBgThumb",style:(("background-image: url( " + _vm.url + " )"))}),_vm._v(" "),_c('div',{staticClass:"pIndex flex-row font-size__small font-weight__bold"},[_c('span',[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('div',{class:['markIsModified', _vm.isModify === true ? 'on' : 'off']})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55d39176","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/noteDocs/p-thumbnail.vue
// module id = null
// module chunks = 